export default __webpack_public_path__ + "static/media/matthew_zoltak.358ebb52.jpg";